import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SapCommunicationOverviewComponent } from './sap-communication-overview/sap-communication-overview.component';

const routes: Routes = [
  {
    path: 'sap-communication',
    component: SapCommunicationOverviewComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SapCommunicationRoutingModule { }
